/** Especialidades para contratos de serviço médico (dropdown no cadastro). */
export const ESPECIALIDADES_MEDICAS = [
  'Clínico Geral',
  'Dermatologia',
  'Ginecologia',
  'Infectologia Ambulatorial',
  'Infectologia Enfermaria',
  'Pneumologia',
  'Psiquiatria',
  'Reumatologia',
  'Cardiologia',
  'Neurologia',
  'Proctologia',
  'Odontologia',
  'Ortopedia',
  'Pediatria',
  'Anestesiologia',
  'Cirurgia Geral',
  'Oftalmologia',
  'Urologia',
  'Endocrinologia',
  'Gastroenterologia',
  'Hematologia',
  'Nefrologia',
  'Oncologia',
  'Outra'
];

export default ESPECIALIDADES_MEDICAS;
